export default __webpack_public_path__ + "static/media/23.50305257.jpg";